import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/kits',
  title: 'Kits',
  endpoint: '/app/laboratory/list',
  breadcrumbs: [],
}
